<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <accessible-radio-group
                v-model="value"
                :label="metadata[`description${this.upperLocale}`]"
                class="body-2 ml-4 mt-0"
                :outline="outline"
                :name="metadata.name"
                :data-meta-id="metadata.id"
                :options="[
                    { label: $t('base.yes'), value: 1 },
                    { label: $t('base.no'), value: 0 }
                ]"
                :mandatory="required"
                :rules="[
                    v => !required || v === 0 || v === 1 || $t('base.errors.requiredField')
                ]"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';
import AccessibleRadioGroup from '@/components/inputs/AccessibleRadioGroup.vue';

export default {
    name: 'worked-for-nsha',
    components: { AccessibleRadioGroup },
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
    },

    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? '' : '';
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
</style>
